<template>
  <div class="row">
    <div class="col-md-5 mb-3 mb-md-0">
      <div class="clients info-block">
        <div class="block">
          <div class="head">
            <div class="row">
              <div class="col-auto  pl-3"> <h2>Транспортні засоби</h2></div>
              <div class="col-auto ml-auto">
                <button @click="createTouristData()">
                  <div v-if="isCreatingTouristData"
                       class="option-loader spinner-border"
                       style="height: 22px; width: 22px; margin-right: 12px;"
                       role="status">
                  </div>
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_16_483)">
                      <rect x="4" y="1.80005" width="30" height="28.2" rx="3" fill="#999DA6"/>
                      <rect x="4" width="30" height="28.2" rx="3" fill="#999DA6"/>
                    </g>
                    <rect x="18.3999" y="9" width="1.2" height="12" fill="white"/>
                    <rect x="25" y="14.4" width="1.2" height="12" transform="rotate(90 25 14.4)" fill="white"/>
                    <defs>
                      <filter id="filter0_d_16_483" x="0" y="0" width="38" height="38" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_483"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16_483" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clients info-block" v-for="(block, blockName) in formDataCars.carsData" :key="blockName">
        <div class="block">
          <div class="head">
            <div class="row">
              <div class="col-auto  pl-3"><h2> <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.49391 10.9502C4.98805 10.9502 5.39235 11.3575 5.39235 11.8552C5.39235 12.3529 4.98805 12.7602 4.49391 12.7602C4.33219 12.7602 3.75719 12.7602 3.59548 12.7602C3.10134 12.7602 2.69704 12.3529 2.69704 11.8552C2.69704 11.3575 3.10134 10.9502 3.59548 10.9502H4.49391ZM18.5095 10.9502C18.0154 10.9502 17.6111 11.3575 17.6111 11.8552C17.6111 12.3529 18.0154 12.7602 18.5095 12.7602H19.408C19.9021 12.7602 20.3064 12.3529 20.3064 11.8552C20.3064 11.3575 19.9021 10.9502 19.408 10.9502C19.2463 10.9502 18.6713 10.9502 18.5095 10.9502ZM21.2048 15.8824V9.81901C21.2048 8.81901 20.4007 8.00905 19.408 8.00905H3.59548C2.6027 8.00905 1.7986 8.81901 1.7986 9.81901V14.9774H6.29079V12.7602C6.29079 11.5113 7.29704 10.4977 8.53688 10.4977H14.3767C15.6166 10.4977 16.6228 11.5113 16.6228 12.7602V14.9774H22.1033C22.5974 14.9774 23.0017 15.3846 23.0017 15.8824V19.095C23.0017 19.5928 22.5974 20 22.1033 20H18.5095C18.0154 20 17.6111 19.5928 17.6111 19.095V16.7873H5.39235V19.095C5.39235 19.5928 4.98805 20 4.49391 20H0.900164C0.406023 20 0.00172631 19.5928 0.00172631 19.095V9.81901C0.00172631 8.75113 0.464422 7.78733 1.19665 7.1267C0.729461 6.81448 0.374578 6.42986 0.114031 5.95928C-0.128547 5.52036 0.0286795 4.97285 0.464422 4.72851C0.900164 4.48416 1.44372 4.64253 1.6863 5.08145C1.83005 5.34389 2.05016 5.55204 2.36012 5.72398L3.46969 2.80543C3.90993 1.64706 4.88923 0.809955 6.08864 0.556561C7.30602 0.303167 9.24665 0 11.5916 0C13.905 0 15.7693 0.294118 16.9283 0.542986C18.1187 0.79638 19.0935 1.63348 19.5293 2.77828L20.6523 5.70136C20.9533 5.52489 21.1779 5.31222 21.3351 5.04977C21.5912 4.62443 22.1437 4.48416 22.5705 4.74208C22.9927 5 23.132 5.55656 22.8759 5.98643C22.6064 6.43439 22.247 6.80995 21.7978 7.11312C22.539 7.77828 23.0062 8.74208 23.0062 9.81448V15.8778C23.0062 16.3756 22.6019 16.7828 22.1078 16.7828C21.6091 16.7873 21.2048 16.3801 21.2048 15.8824ZM4.10309 6.1991H18.9138L17.8537 3.42986C17.6336 2.85973 17.1484 2.43891 16.5554 2.31222C15.4818 2.08597 13.7478 1.80995 11.5916 1.80995C9.39938 1.80995 7.58903 2.0905 6.45251 2.33032C5.85505 2.45701 5.3654 2.8733 5.14528 3.45249L4.10309 6.1991ZM21.2048 18.19V16.7873H19.408V18.19H21.2048ZM8.08766 14.9774H9.21071V14.1176C9.21071 13.6199 9.61501 13.2127 10.1091 13.2127C10.6033 13.2127 11.0076 13.6199 11.0076 14.1176V14.9774H11.906V14.1176C11.906 13.6199 12.3103 13.2127 12.8045 13.2127C13.2986 13.2127 13.7029 13.6199 13.7029 14.1176V14.9774H14.8259V12.7602C14.8259 12.5113 14.6238 12.3077 14.3767 12.3077H8.53688C8.28981 12.3077 8.08766 12.5113 8.08766 12.7602V14.9774ZM1.7986 16.7873V18.19H3.59548V16.7873H1.7986Z" fill="#24282C"/>
              </svg> {{ block.title }}</h2></div>
              <div class="col-auto ml-auto">
                <button @click="deleteCarData()">
                  <div v-if="isDeletingCarData"
                       class="option-loader spinner-border"
                       style="height: 22px; width: 22px; margin-right: 12px;"
                       role="status">
                  </div>
                  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2.4 21.6C2.4 22.9236 3.4764 24 4.8 24H16.8C18.1236 24 19.2 22.9236 19.2 21.6V7.2H21.6V4.8H16.8V2.4C16.8 1.0764 15.7236 0 14.4 0H7.2C5.8764 0 4.8 1.0764 4.8 2.4V4.8H0V7.2H2.4V21.6ZM7.2 2.4H14.4V4.8H7.2V2.4ZM6 7.2H16.8L16.8012 21.6H4.8V7.2H6Z" fill="#24282C"/>
                    <path d="M7.19995 9.6001H9.59995V19.2001H7.19995V9.6001ZM12 9.6001H14.4V19.2001H12V9.6001Z" fill="#24282C"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="body">
            <div class="interactive-form">
             <div v-for="(field, fieldName) in block.fields" :key="fieldName">
               <div v-if="fieldName != 'orders'">
                 <div v-if="!editing || editField !== fieldName" @click="startEditing(fieldName, blockName)">
                   <div class="row">
                     <div class="col-3 text-left label-field">{{ field.label }}:</div>
                     <div  v-if="fieldName == 'client_type'"  class="col-9 text-right text-field">{{ showUserType(field) }}</div>
                     <div  v-else  class="col-9 text-right text-field">{{ field.value }}</div>
                   </div>
                 </div>
                 <div v-else>
                   <div class="row">
                     <div class="col-3 text-left label-field"><label for="">{{ field.label }}:</label></div>
                     <div class="col-9 text-right text-field">
                       <select v-if="fieldName == 'client_type'" v-model="formBuffer[blockName].fields[fieldName].value" @blur="saveField(fieldName, blockName)" @keydown.enter="saveField(fieldName, blockName)">
                         <option v-for="type in userTypesList" :key="type.id" :value="type.id">{{type.name}}</option>
                       </select>
                       <input v-else v-model="formBuffer[blockName].fields[fieldName].value" @blur="saveField(fieldName, blockName)" @keydown.enter="saveField(fieldName, blockName)">
                     </div>
                   </div>

                 </div>
               </div>
               <div v-else>
                 <div class="col-12">
                   <hr>
                 </div>
                 <h5 class="text-center">Діючи поліси</h5>
                 <div v-if="field">
                   <div class="row">
                     <div class="col-auto  pl-3">
                       Номер поліса
                     </div>
                     <div class="col-auto ml-auto">
                       Дата закінчення
                     </div>
                   </div>
                   <div v-for="order in field" :key="order.id">
                     <div class="row">
                       <div class="col-auto  pl-3">
                         {{order.mtsbu_code}} ( {{ order.orderType }})
                       </div>
                       <div class="col-auto ml-auto">
                         {{ showDateFormat(order.finished_at)}}
                       </div>
                     </div>

                   </div>
                 </div>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-none d-md-block col-md-fixed  mb-3">
      <div class="vr"></div>
    </div>
    <div class="col-md-5">
      <div class="clients info-block" v-for="(block, blockName) in formDataTourist" :key="blockName">
        <div class="block">
          <div class="head">
            <div class="row">
              <div class="col-auto  pl-3"> <h2>{{ block.title }}</h2></div>
              <div class="col-auto ml-auto">
                <button @click="createTouristData()">
                  <div v-if="isCreatingTouristData"
                       class="option-loader spinner-border"
                       style="height: 22px; width: 22px; margin-right: 12px;"
                       role="status">
                  </div>
                  <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_16_483)">
                      <rect x="4" y="1.80005" width="30" height="28.2" rx="3" fill="#999DA6"/>
                      <rect x="4" width="30" height="28.2" rx="3" fill="#999DA6"/>
                    </g>
                    <rect x="18.3999" y="9" width="1.2" height="12" fill="white"/>
                    <rect x="25" y="14.4" width="1.2" height="12" transform="rotate(90 25 14.4)" fill="white"/>
                    <defs>
                      <filter id="filter0_d_16_483" x="0" y="0" width="38" height="38" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16_483"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16_483" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="body">
            <div class="interactive-form">
              <div v-for="field in block.data" :key="field.id">
                <div class="row">
                  <div class="col-6 text-left label-field">{{ field.note }}</div>
                  <div class="col-3 text-right text-field">{{ field.agent.name + " " +  field.agent.surname + " " +  field.agent.patronymic  }}</div>
                  <div class="col-3 text-right text-field">
                    <div class="row">
                      <div class="col">{{  }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import {getData, updateClient} from "@/api/client";

export default {
  data() {
    return {
      isCreatingTouristData: false,
      isDeletingCarData: false,
      editing: false,
      editField: '',
      formBuffer: {},
      condition: {
        isLoadClientData: false,
        isLoadTable: true,
        isLoadXml: false,
        isMobile: false,
      },
      formDataCars: {
        carsData: []
      },
      formDataTourist: {
        touristData: {
          title: 'Об’єкти туристичного страхування',
          data:{}
        }
      },
    }
  },
  created() {
    this.getClientData(this.$route.params.clientId);
  },
  methods: {
    showDateFormat: function(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    createTouristData(){
      this.isCreatingTouristData = true;
      this.$alert("Нажаль тут поки що не працює :(");
      this.isCreatingTouristData = false;
    },
    deleteCarData(){
      this.isDeletingCarData = true;
      this.$alert("Нажаль тут поки що не працює :(");
      this.isDeletingCarData = false;
    },
    startEditing(field, blockName) {

      if(field == 'adress' || field == 'agentName') return;

      this.editing = true;
      this.editField = field;
      this.formBuffer[blockName] = { ...this.formData[blockName] };
    },
    saveField(field, blockName) {
      this.formData[blockName].fields[field] = this.formBuffer[blockName].fields[field];
      this.editing = false;
      this.editField = '';
      //console.log('saveField',field, this.formData[blockName].fields[field],this.formData);
      // Тут вы можете выполнить запрос на бэкенд для сохранения данных
      // Например, через Axios или другой метод работы с API

      let params = {'clients_id':this.$route.params.clientId,'field':field, 'blockName':blockName, 'fieldData':this.formData[blockName].fields[field]};

      updateClient(params).then((response) => {
        if(response.statusText == "OK"){

        }
      }).catch((error) => {
      });
    },
    getClientData: function(clientId) {
      this.condition.isLoadClientData = true;
      let params = {
        "clientId":clientId,
        "requestType": "getClientData"
      };

      getData(params)
          .then((response) => {
            if(response.statusText == "OK"){
              this.vehicles = response.data.data.items[0].vehicles;
              this.ordersList = response.data.data.items[0].orders;
                this.vehicles.forEach((value, index) => {
                  let data = {
                    title: value.registration_number,
                    fields: {
                      object_type: { value: 'ТЗ', label: 'Тип об’єкта' },
                      mark: { value: value.mark_id, label: 'Марка' },
                      model: { value: value.model_id, label: 'Модель' },
                      year: { value: value.year, label: 'Рік випуску' },
                      vin: { value: value.vin, label: 'VIN-код:' },
                      capacity: { value: value.type, label: 'Об’єм двигуна' },
                      registration_number: { value: value.registration_number, label: 'Об’єм двигуна' },
                      city_registration: { value: value.registration_place_id, label: 'Місце реєстрації' },
                      orders : value?.orders || null
                    }};
                  this.formDataCars.carsData.push(data);
                })
              }

              this.condition.isLoadClientData = false;
          }).catch((error) => {
        this.condition.isLoadClientData = false;
      });
    },
  }

}
</script>

<style scoped>
.column-block {
  a {
    .text {
      margin-left: 5px;
      line-height: 26px;
    }
  }
}
h2 svg{
  margin-right: 15px;
}
.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentColor;
  opacity: .25;
  height: 100%;
}

.clients.info-block {
  padding: 20px;
}
.clients.info-block{
  border: none;
}
.clients.info-block .block{
  border: 1px solid #DDE2E5;
  border-radius: 3px;
}
.clients.info-block .head {
  border-bottom: 1px solid #DDE2E5;
  height: 51px;
  background: #F6F7FB;
}
.clients.info-block .head h2{
  display: flex;
  justify-content: left;
  align-items: center;
  height: 100%;
  padding-left: 15px;
}
.clients.info-block .body {
  padding: 15px;
}
.interactive-form{
  p {
    display: inline;
    border: none;
    background: none;
    cursor: pointer;
  }
  input {
    /*border: none;*/
    outline: none;
    background: none;
  }
}
.info-block h2{
  font-weight: 700;
}
.info-block .label-field{
  font-size: 14px;
  font-weight: 700;
  color: #999DA6;
}
.info-block .text-field{
  font-size: 15px;
  font-weight: 700;
  color: #24282C;
}
.info-block .text-field input {
  border: 1px solid #999DA6;
  text-align: right;
}
.info-block  button {
  border: none;
  background: transparent;
  padding-top: 8px;
}
</style>
